const styles = {
  icon: {
    marginRight: 10,
  },
};

export default styles;
